document.addEventListener('DOMContentLoaded', () => {

    class SiblingProducts extends HTMLElement{
        constructor(){
            super();

            this.section = this.closest('section') || this.closest('.pop-up-inner');
            this.name = this.dataset.name;

            this.addEventListener('change', this.onChange.bind(this));
        }

        onChange () {
            this.updateProduct();

            if(this.product){
                if(this.name == 'main-product'){
                    this.updateContent();
                    this.renderOtherSections();
                } else if(this.name == 'quick-view') {
                    this.updateQV();
                }
            }
        }

        updateProduct () {
            const inputs = this.querySelectorAll('input');
            inputs.forEach(input => {
                if(input.checked) this.product = input.value;
            })

            if(!this.product) this.product = this.querySelector('select').value;
        }

        async updateContent () {
            this.section.classList.add('product-changing');

            window.history.replaceState({ }, '', `/products/${this.product}`);

            const response = await fetch(`/products/${this.product}?section_id=${this.dataset.section}`);
            const text = await response.text();
            const html = new DOMParser().parseFromString(text, 'text/html');

            const toChange = ['[product-changing]', '[variant-changing]'];
            toChange.forEach(string => {
                let sources = html.querySelectorAll(string);
                let destinations = document.querySelectorAll(string);
                sources.forEach((source, index) => {
                    if(!destinations[index]) return;
                    destinations[index].innerHTML = source.innerHTML;
                })
            })

            this.section.classList.remove('product-changing');
            product.init();
            init(this.section);

            loadFbt();
        }

        async renderOtherSections () {
            const toChanges = Array.from(document.querySelectorAll('[to-change]'));
            
            const HTMLs = await Promise.all(toChanges.map(toChange => {
                const url = `?section_id=${toChange.dataset.section}`;
                return this.getHTML(url);
            }));

            HTMLs.forEach(html => {
                const sectionId = html.querySelector('[data-section]').getAttribute('data-section');
                const destination = document.querySelector(`#shopify-section-${sectionId}`);
                if(destination) {
                    destination.innerHTML = html.innerHTML;
                }
            })
        }

        async getHTML (url) {
            const response = await fetch(url)
            const text = await response.text();
            const html = new DOMParser().parseFromString(text, 'text/html');
            const toRender = html.querySelector('.shopify-section');
            return toRender;
        }

        async updateQV () {
            this.section.classList.add('loading');
    
            fetch(`/products/${this.product}?view=quick-view&section_id=${this.dataset.section}`)
                .then(response => response.text())
                .then(text => {
                    const html = new DOMParser().parseFromString(text, 'text/html');
                    
                    let source = html.querySelector('.pop-up-inner');

                    if(source) this.section.innerHTML = source.innerHTML;
                    
                    this.section.classList.remove('loading');
                    init(this.section);
                })
        }
    }
    customElements.define('sibling-products', SiblingProducts);

    class VariantPicker extends HTMLElement{
        constructor(){
            super();

            this.inputId = this.querySelector('[name="id"]');
            this.section = this.closest('section') || this.closest('.pop-up-inner');
            this.name = this.dataset.name;

            this.addEventListener('change', this.onVariantChange.bind(this));

            this.updateUnavailableOptions();
        }

        onVariantChange () {
            this.updateOptions();
            this.updateMasterId();

            if(!this.currentVariant) return;

            if(this.name == 'main-product'){
                this.updateHistory();
                this.updateInput();
                this.updateContent();
                this.updateImage();
                this.updateUnavailableOptions();
            } else if(this.name == 'quick-view'){
                this.updateQV();
                this.updateInput();
                this.updateUnavailableOptions();
            }
        }

        updateOptions () {
            const groups = Array.from(this.section.querySelectorAll('variant-picker .group'));
            this.options = groups.map(group => {
                const inputs = group.querySelectorAll('input[type="radio"]');
                if (inputs.length > 0) {
                    const checked = Array.from(inputs).find(input => input.checked);
                    return checked ? checked.value : null;
                }

                const select = group.querySelector('select');
                if (select) {
                    return select.value;
                }

                return null;
            });
        }

        updateMasterId() {
            const selectedOptions = [...this.options].sort().join('|');

            this.currentVariant = this.getVariantData().find((variant) => {
                const variantOptions = [...variant.options].sort().join('|');
                return selectedOptions === variantOptions;
            });
        }

        updateHistory () {
            window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }

        updateInput () {
            if(this.inputId) this.inputId.value = this.currentVariant.id;
        }

        updateContent () {

            this.section.classList.add('variant-changing');

            fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
                .then(response => response.text())
                .then(text => {
                    const html = new DOMParser().parseFromString(text, 'text/html');
                    const toChange = ['[variant-changing]'];
                    toChange.forEach(string => {
                        let sources = html.querySelectorAll(string);
                        let destinations = document.querySelectorAll(string);
                        sources.forEach((source, index) => {
                            if(!destinations[index]) return;
                            destinations[index].innerHTML = source.innerHTML;
                        });
                    });

                    const secondButton = this.section.querySelector('#dynamic-button');

                    if (secondButton) {
                        if (this.currentVariant.available) secondButton.style.display = 'block';
                        else secondButton.style.display = 'none';
                    }

                    this.section.classList.remove('variant-changing');
                    init(this.section);
                })
        }

        updateImage () {
            if(this.currentVariant.featured_media) product.imgs.goToSlide(this.currentVariant.featured_media.position - 1);
        }

        async updateQV () {
            this.section.classList.add('loading');
    
            fetch(`${this.dataset.url}?view=quick-view&section_id=${this.dataset.section}&variant=${this.currentVariant.id}`)
                .then(response => response.text())
                .then(text => {
                    const html = new DOMParser().parseFromString(text, 'text/html');
                    
                    let source = html.querySelector('.pop-up-inner');
                    if(!source) source = html.querySelector('section');

                    if(source) this.section.innerHTML = source.innerHTML;
                    
                    this.section.classList.remove('loading');
                    init(this.section);
                })
        }

        updateUnavailableOptions() {
            
            if (!this.currentVariant){
                this.updateOptions();
                this.updateMasterId();
                if(!this.currentVariant) return;
            }

            const variantList = this.getVariantData().filter(v => v.available);
            const selectedOption1 = this.currentVariant?.option1 || '';
            const selectedOption2 = this.currentVariant?.option2 || '';    
            const hasTwoOptions = !!selectedOption2;

            const radioInputs = this.querySelectorAll('input[type="radio"]');
        
            radioInputs.forEach(input => {
                const value = input.value;
                const label = input.nextElementSibling;
                if(!label) return;

                const matching = hasTwoOptions
                    ? variantList.find(v =>
                        (v.option1 === selectedOption1 && v.option2 === value) ||
                        (v.option2 === selectedOption2 && v.option1 === value)
                    )
                    : variantList.find(v => v.option1 === value);

                label.classList.toggle('soldout', !matching);
            });

            const selects = this.querySelectorAll('select');
            selects.forEach((select) => {
                Array.from(select.options).forEach((option) => {
                const value = option.value;

                const matching = hasTwoOptions
                    ? variantList.find(v =>
                        (v.option1 === selectedOption1 && v.option2 === value) ||
                        (v.option2 === selectedOption2 && v.option1 === value)
                    )
                    : variantList.find(v => v.option1 === value);

                if(!matching){
                    option.textContent = `${ option.textContent }${ select.dataset.soldout }`;
                }
            });
            });
        
        }

        getVariantData() {
            this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
            return this.variantData;
        }  
    }
    customElements.define('variant-picker', VariantPicker);

    class VariantBundle extends VariantPicker{
        constructor(){
            super()
            this.initButton();
        }

        onVariantChange () {
            this.updateMasterId();

            if(!this.currentVariant) return;

            if(this.name == 'main-product'){
                this.updateHistory();
                this.updateContent();
                this.updateImage();
            } else if(this.name == 'quick-view'){
                this.updateQV();
            }
        }

        updateMasterId () {
            const id = parseInt(Array.from(this.querySelectorAll('input[type="radio"]')).find((input) => input.checked).value);
            this.getVariantData().forEach((variant) => {
                if(variant.id == id) this.currentVariant = variant; 
            });
        }

        initButton () {
            console.log('xx');
            this.btns = this.querySelectorAll('button');

            this.btns.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const id = btn.closest('label').getAttribute('for');
                    const input = this.querySelector(`#${id}`);
                    
                    input.checked = true;
                    this.dispatchEvent(new Event('change'));
                    
                    this.closest('form').dispatchEvent(new Event('submit'));
                })
            });
        }
    }
    customElements.define('variant-bundle', VariantBundle);

}, { passive: true});